module.exports = __webpack_public_path__ + "static/media/earthly_view.78de7c0f.jpg";